import { createAction, props } from '@ngrx/store';

import {
  CreateEnquiriesCategoryDto,
  CreateEnquiriesTenantSettingsDto,
  CreateEnquiryRequestDto,
  EnquiriesCategoryDto,
  EnquiryDto,
  EnquiryTenantSettingsDto,
  PutEnquiriesTenantSettingsRequestParams,
} from '@careapp-group/ng-sdk';
import {
  BaseFilterType,
  CaEntityActionsFactory,
} from '../../../store/entity-state/entity-actions-factory';
import { EnquiriesCategoryWrapper } from './enquiries-tenant-categories.reducer';

export class EnquiriesTenantCategoryActions extends CaEntityActionsFactory<
  EnquiriesCategoryWrapper,
  CreateEnquiriesCategoryDto,
  CreateEnquiriesCategoryDto,
  BaseFilterType
> {
  constructor() {
    super('enquiriesTenantCategories');
  }
}

export const EnquiriesTenantCategories = new EnquiriesTenantCategoryActions();
